import axios from 'axios';
import store from "@/store/store";
import {modalController, toastController} from "@ionic/vue";
import {AuthLib} from "vue-app-auth-lib";
import i18n from "@/i18n/i18n";

export default function interceptors() {
    axios.interceptors.request.use((config) => {
        const token = AuthLib.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // config.headers['ngrok-skip-browser-warning'] = 'true';
        store.commit('loading', true);
        return config;
    }, function(err) {
        store.commit('loading', false);
        return Promise.reject(err);
    });

    axios.interceptors.response.use((config) => {
        store.commit('loading', false);
        return config;
    }, async function (error) {
        store.commit('loading', false);

        if (error.response.status === 401) {
            while (await modalController.getTop()) {
                await modalController.dismiss(null, "cancel")
            }
            const toast = await toastController.create({
                message: i18n.global.t("interceptors.noAuthorized"),
                duration: 1500,
                position: "bottom",
            });
            await toast.present();
        } else
            if (error.response.status === 422) {
            for(let key in error.response.data.errors){
                const toast = await toastController.create({
                    message: error.response.data.errors[key][0],
                    duration: 1500,
                    position: "bottom",
                });
                await toast.present();
            }
        }
        return Promise.reject(error.response);
    });

}
